import { Component } from '@angular/core';

@Component({
    selector: 'app-other-plans-details',
    templateUrl: './other-plans-details.component.html',
    styleUrls: ['./other-plans-details.component.scss'],
    standalone: false
})
export class OtherPlansDetailsComponent {
  constructor() {}
}
